var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h4',[_vm._v(_vm._s(_vm.user.name)+" "+_vm._s(_vm.user.last_name))]),_c('form-table-items',{attrs:{"items":_vm.items}}),_c('b-row',{staticClass:"pt-3 mt-3"},[_c('pagination',{attrs:{"meta":_vm.pagination,"on-change-page":_vm.changeProductsPage}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }